import React from "react";
import { Button } from "@mui/material";
import { useNavigate } from "react-router";
import "./card.scss";

const PrizingCard = (props) => {
  const navigate = useNavigate();

  const handleClick = (item)=>{
    if(item === 'Log In'){
      navigate('/login')
    }else if(item === 'Upgrade'){
      navigate('/stripepayment')
    }
  }
  
  return (
    <>
      {props.props.map((item) => (
        <div className="card" key={item.title}>
          {/* <img src={props.img} alt={props.title} /> */}
          <div className="card-title">
            <h1>{item.title}</h1>
            <span className="card-price">{item.price}</span>
          </div>
          <div className="card-body">
            <span>
              <ul>
                {item.features.map((feature, index) => (
                  <li key={index}>{feature}</li>
                ))}
              </ul>
            </span>
          </div>
          <div className="card-button">
            <Button variant="contained" color="primary" className="choose-button" onClick={()=>handleClick(item.text)} disabled={item.disabled}>
              {item.text}
            </Button>
          </div>
        </div>
      ))}
    </>
  );
};

export default PrizingCard;
